// can edit transactions
export const PAYMENTS_TRANSACTIONS_WRITE = 'payments-transactions-write';

// can send emails
export const PAYMENTS_MANUAL_EMAILS = 'payments-manual-emails';

// is JITA user
export const JITA_USER = 'jita-user';